import React from "react";
import { Loader2 } from "lucide-react";
import { useAuth } from "./AuthContext";

export default function AuthSessionLoader({
  message = "Checking your session…",
  testId,
  secondaryAction,
}) {
  const { authError, retryAuth } = useAuth();

  return (
    <div
      className="min-h-[calc(100vh-4rem)] grid place-items-center px-6"
      data-testid={testId}
    >
      <div className="flex max-w-sm flex-col items-center gap-3 text-center">
        {!authError && (
          <Loader2 size={24} className="animate-spin text-[var(--zc-accent)]" />
        )}
        <p className="zc-hint">{authError || message}</p>
        {authError && (
          <div className="flex flex-wrap items-center justify-center gap-2 mt-1">
            <button
              type="button"
              className="zc-btn zc-btn-primary"
              onClick={retryAuth}
              data-testid="auth-retry-btn"
            >
              Try again
            </button>
            {secondaryAction && (
              <button
                type="button"
                className="zc-btn zc-btn-outline-primary"
                onClick={secondaryAction.onClick}
                data-testid={secondaryAction.testId}
              >
                {secondaryAction.label}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
